"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteTooltipStyles = exports.useAutocompleteOneLineStyles = exports.useAutocompleteStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useAutocompleteStyles = styles_1.makeStyles(function (_a) {
    var shadows = _a.shadows;
    return ({
        paper: {
            boxShadow: shadows[8],
        },
        inputRoot: {
            paddingLeft: "6px !important",
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
        },
        input: {
            padding: "6px 8px !important",
            "&:first-child": {
                marginLeft: -2,
            },
        },
    });
});
exports.useAutocompleteOneLineStyles = styles_1.makeStyles(function (_a) {
    var shadows = _a.shadows;
    return ({
        paper: {
            boxShadow: shadows[8],
        },
        inputRoot: {
            paddingLeft: "6px !important",
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
            flexWrap: "nowrap",
        },
        input: {
            padding: "6px 8px !important",
            "&:first-child": {
                marginLeft: -2,
            },
        },
        line: {
            display: "flex",
            overflow: "auto",
            maxWidth: "100%",
            "& > *": {
                whiteSpace: "nowrap",
            },
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
    });
});
exports.useAutocompleteTooltipStyles = styles_1.makeStyles(function () { return ({
    tooltipPlacementBottom: {
        marginTop: 8,
    },
}); });
//# sourceMappingURL=Autocomplete.styles.js.map